
export const EduquestTestidUpload = (data) => {
    var formdata = new FormData()
    console.log(data);

    if(data.attachments){
        formdata.append('attachments',data.attachments.rawFile)
    }
     if(data.test_name){
        formdata.append('test_name',data.test_name)
    }

    return formdata;
}